import React from 'react';
import useDisplayHomeWrapper from '../../hooks/useDisplayHomeWrapper';
import AdvisoryFlowMainContainerHomeContent from './AdvisoryFlowMainContainerHomeContent';
import AdvisoryFlowMainContainerContent from './AdvisoryFlowMainContainerContent';

export const AdvisoryFlowMainContainerId = 'advisoryFlowMainContainer';

const AdvisoryFlowMainContainer: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
  ...otherProps
}) => {
  const isHomeQuestion = useDisplayHomeWrapper();

  // HOME QUESTIONS
  if (isHomeQuestion)
    return (
      <AdvisoryFlowMainContainerHomeContent>
        {children}
      </AdvisoryFlowMainContainerHomeContent>
    );

  return (
    <AdvisoryFlowMainContainerContent {...otherProps}>
      {children}
    </AdvisoryFlowMainContainerContent>
  );
};

export default AdvisoryFlowMainContainer;
